import { FormType } from "../../models";
import RequestFrom from "./RequestForm";

const CreateGuestAccount = () => {
  return <RequestFrom formType={FormType.ContinueGuest} />;
};

export default CreateGuestAccount;
